import {Component, ComponentFactoryResolver, Input, OnInit, ViewChild} from '@angular/core';
import {Warehouse} from '../../../warehouse';
import {WarehouseProfilesFormDirective} from '../warehouse-profiles-form.directive';
import {WarehouseProfilesForm} from '../warehouse-profiles-form';

@Component({
    selector: 'app-warehouse-profiles-form-selector',
    templateUrl: './warehouse-profiles-form-selector.component.html',
    styleUrls: ['../../project-form.css']
})
export class WarehouseProfilesFormSelectorComponent implements OnInit {
    @ViewChild(WarehouseProfilesFormDirective)
    private warehouseProfilesForm: WarehouseProfilesFormDirective;
    @Input() warehouse: Warehouse;
    componentRef : any;

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnInit() {
        this.loadForm();
    }

    loadForm() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
            Warehouse.getWarehouseProfilesFormComponent(this.warehouse.type));

        const viewContainerRef = this.warehouseProfilesForm.viewContainerRef;
        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
        this.componentRef = <WarehouseProfilesForm>componentRef.instance;
        this.componentRef.warehouse = this.warehouse;
    }
    
    getProfileFormSelectorComponent(){
        return this.componentRef;
    }
}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-profiles-form/warehouse-profiles-form-selector/warehouse-profiles-form-selector.component.ts